import { Module } from 'vuex';
import {
  action,
  actionCreatorFactory,
  combineAction,
  combineMutation,
  mutation,
} from 'vuex-typescript-fsa/lib';
import { RootState } from '@/store';
import {
  CvSectionDate,
  CvSectionDateItem,
  CvSectionDateItemResponse,
  CvSectionDateResponse,
  UpdateCvSectionDateItemRequest,
} from '@/../gen';

export const namespace = 'cvSectionDateItemEdit';
const actionCreator = actionCreatorFactory(namespace);

export const GetCvSectionDate = actionCreator<{
  params: {
    cv_id: number;
    id: number;
  };
}>('GET_CV_SECTION_DATE');
export const SetCvSectionDate = actionCreator<CvSectionDateResponse>(
  'SET_CV_SECTION_DATE'
);
export const GetCvSectionDateItem = actionCreator<{
  params: {
    cv_id: number;
    cv_section_date_id: number;
    id: number;
  };
}>('GET_CV_SECTION_DATE_ITEM');
export const SetCvSectionDateItem = actionCreator<CvSectionDateItemResponse>(
  'SET_CV_SECTION_DATE_ITEM'
);
export const UpdateCvSectionDateItem = actionCreator<{
  params: {
    cv_id: number;
    cv_section_date_id: number;
    id: number;
  };
  body: UpdateCvSectionDateItemRequest;
}>('UPDATE_CV_SECTION_DATE_ITEM');
export const DeleteCvSectionDateItem = actionCreator<{
  params: {
    cv_id: number;
    cv_section_date_id: number;
    id: number;
  };
}>('DELETE_CV_SECTION_DATE_ITEM');
export const ResetState = actionCreator<null>('RESET_STATE');

export interface State {
  cvSectionDate: CvSectionDate;
  cvSectionDateItem: CvSectionDateItem;
}

const initialState = (): State => {
  return {
    cvSectionDate: null,
    cvSectionDateItem: null,
  };
};

export const module: Module<State, RootState> = {
  namespaced: true,
  state: initialState,
  actions: combineAction(
    action(GetCvSectionDate, async function(context, action) {
      const { data } = await this.proffApi.getCvSectionDate(
        action.payload.params.cv_id,
        action.payload.params.id
      );
      context.commit(SetCvSectionDate(data.data));
    }),
    action(GetCvSectionDateItem, async function(context, action) {
      const { data } = await this.proffApi.getCvSectionDateItem(
        action.payload.params.cv_id,
        action.payload.params.cv_section_date_id,
        action.payload.params.id
      );
      context.commit(SetCvSectionDateItem(data.data));
    }),
    action(UpdateCvSectionDateItem, async function(context, action) {
      const { data } = await this.proffApi.updateCvSectionDateItem(
        action.payload.params.cv_id,
        action.payload.params.cv_section_date_id,
        action.payload.params.id,
        action.payload.body
      );
      context.commit(SetCvSectionDateItem(data.data));
    }),
    action(DeleteCvSectionDateItem, async function(context, action) {
      await this.proffApi.deleteCvSectionDateItem(
        action.payload.params.cv_id,
        action.payload.params.cv_section_date_id,
        action.payload.params.id
      );
      context.commit(SetCvSectionDateItem(null));
    }),
    action(ResetState, function(context, action) {
      context.commit(ResetState(action.payload));
    })
  ),
  mutations: combineMutation(
    mutation(SetCvSectionDate, (state, action) => {
      state.cvSectionDate = action.payload?.attributes;
    }),
    mutation(SetCvSectionDateItem, (state, action) => {
      state.cvSectionDateItem = action.payload?.attributes;
    }),
    mutation(ResetState, state => {
      Object.assign(state, initialState());
    })
  ),
  getters: {
    cvSectionDate: state => state.cvSectionDate,
    cvSectionDateItem: state => state.cvSectionDateItem,
  },
};
